import { render, staticRenderFns } from "./WarehouseFlyer.vue?vue&type=template&id=7de4b965"
import script from "./WarehouseFlyer.vue?vue&type=script&lang=js"
export * from "./WarehouseFlyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports